module.exports = __webpack_public_path__ + "b4759d5177f8c2c71017ca4478ae7e3d.png";